// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
import AgoraRTC, {
  ICameraVideoTrack,
  IMicrophoneAudioTrack,
} from "agora-rtc-sdk-ng";
import AgoraRTM, { RtmChannel } from "agora-rtm-sdk";
import {
  appID,
  ClientRole,
  generateRTCToken,
  generateRTMToken,
  getUniqueID,
} from "../common-definitions/agora-token-generation";

export const client = AgoraRTC.createClient({ mode: "live", codec: "h264" });
export const rtmClient = AgoraRTM.createInstance(appID);
let rtmChanel: RtmChannel;
let isJoined = false;
const localStreams = {
  uid: "",
  audio: {} as IMicrophoneAudioTrack,
  camera: {} as ICameraVideoTrack,
};

// join a channel
export const joinChannel = async (chanel: string) => {
  if (
    ["view.live-kun.jp", "staging.d1xk05lz02ufhs.amplifyapp.com"].includes(
      window.location.host
    )
  ) {
    AgoraRTC.enableLogUpload();
    AgoraRTC.setLogLevel(3);
  }
  const uniqueId = getUniqueID();
  const rtcToken = generateRTCToken(ClientRole.SUBSCRIBER, 0, chanel);
  client.setClientRole("audience");
  if (rtcToken) {
    await client.join(appID, chanel, rtcToken);
  }
  rtmChanel = rtmClient.createChannel(chanel);
  const rtmToken = generateRTMToken(ClientRole.PUBLISHER, `${uniqueId}`);
  if (rtmToken && !isJoined) {
    isJoined = true;
    await rtmClient.login({ uid: `${uniqueId}`, token: rtmToken });
    await rtmChanel.join();
  }
};

export const leaveChannel = async () => {
  client?.leave();
  if (Object.keys(localStreams.audio).length > 0) {
    localStreams.audio.close();
    localStreams.camera.close();
    rtmClient.logout();
  }
};

export const getRtmChanel = () => {
  return rtmChanel;
};
